import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgAiIcon6 = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 48 48"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <circle cx={24} cy={24} r={24} fill="#000" />
    <g
      transform="translate(24 24) scale(1.2) translate(-11.5491 -11.7147)"
      fill="#fff"
    >
      <path d="M12.2588 0.0721L8.7303 3.0489c-.0702.0593-.1108.1471-.1108.2397v1.5912c0 .1721.1376.3117.3074.3117h1.6857c.0717 0 .1413-.0255.1965-.0721l3.5589-3.0026c.0702-.0592.1108-.147.1108-.2396V.3117C14.4787.1395 14.3411 0 14.1714 0h-1.7161c-.0718 0-.1414.0255-.1965.0721Z" />
      <path d="M12.2588 18.31l-3.5285 2.9769c-.0702.0592-.1108.147-.1108.2396v1.5912c0 .1722.1376.3117.3074.3117h1.6857c.0717 0 .1413-.0255.1965-.072l3.5589-3.0026c.0702-.0592.1108-.147.1108-.2396v-1.5655c0-.1722-.1376-.3117-.3073-.3117h-1.7161c-.0718 0-.1413.0255-.1966.072Z" />
      <path d="m20.1671 3.9911-4.5702-.4258c-.0909-.0085-.1808.0245-.2454.09l-1.1092 1.1251c-.12.1217-.12.3191 0 .4408l1.1919 1.2091c.0508.0515.1177.0833.1892.09l4.6097.4295c.0909.0084.1808-.0245.2454-.09l1.0913-1.107c.12-.1217.12-.3191 0-.4408L20.3563 4.0811c-.0508-.0515-.1177-.0833-.1892-.09Z" />
      <path d="m7.4533 16.8873-4.5702-.4258c-.091-.0085-.1809.0245-.2454.09L1.5284 17.6766c-.12.1217-.12.319 0 .4408l1.192 1.2091c.0507.0515.1177.0833.1891.09l4.6097.4295c.091.0085.1809-.0245.2454-.09l1.0914-1.107c.12-.1217.12-.319 0-.4408L7.6424 16.9773c-.0507-.0515-.1177-.0833-.1891-.09Z" />
      <path d="m23.0272 12.4346-2.9348-3.5791c-.0584-.0712-.145-.1124-.2363-.1124H18.2874c-.1697 0-.3073.1396-.3073.3117v1.7099c0 .0728.0252.1433.0711.1993l2.9601 3.61c.0583.0712.1449.1123.2362.1123h1.5434c.1697 0 .3073-.1395.3073-.3117V12.6339c0-.0728-.0251-.1433-.071-.1993Z" />
      <path d="M5.047 12.4346 2.1123 8.8555c-.0584-.0712-.145-.1124-.2363-.1124H.3073C.1376 8.7431 0 8.8827 0 9.0548v1.7099c0 .0728.0251.1433.071.1993l2.9602 3.61c.0583.0712.1449.1123.2362.1123h1.5434c.1697 0 .3073-.1395.3073-.3117V12.6339c0-.0728-.0251-.1433-.071-.1993Z" />
      <path d="m19.1635 20.4563.4198-4.6357c.0084-.0922-.0241-.1834-.0887-.2489L18.3854 14.4465c-.12-.1217-.3146-.1217-.4346 0L16.7588 15.6556c-.0507.0515-.0821.1194-.0887.1919l-.4234 4.6757c-.0084.0923.0241.1835.0887.249l1.0913 1.1069c.12.1218.3146.1218.4346 0l1.2135-1.2308c.0507-.0515.0821-.1194.0887-.192Z" />
      <path d="m6.4496 7.5601.4199-4.6357c.0083-.0922-.0242-.1834-.0888-.2489L5.6715 1.5503c-.12-.1217-.3146-.1217-.4346 0L4.045 2.7594c-.0508.0515-.0822.1194-.0888.1919l-.4234 4.6757c-.0084.0923.0241.1835.0887.249l1.0913 1.107c.12.1217.3146.1217.4346 0L6.3609 7.752c.0508-.0515.0822-.1194.0888-.192Z" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgAiIcon6);
const Memo = memo(ForwardRef);
export default Memo;
